// hooks/useEndDateCalculation.ts
import { useEffect } from 'react';
import type { Medication } from '../types/medication';

export const useEndDateCalculation = (
  currentMedication: Medication,
  updateCurrentMedication: (field: keyof Medication, value: string | number) => void
) => {
  useEffect(() => {
    if (
      currentMedication.startDate &&
      currentMedication.duration &&
      currentMedication.durationUnit
    ) {
      const startDate = new Date(currentMedication.startDate);
      const endDate = new Date(startDate);

      switch (currentMedication.durationUnit) {
        case "Jours":
          endDate.setDate(startDate.getDate() + currentMedication.duration);
          break;
        case "Semaine(s)":
          endDate.setDate(startDate.getDate() + currentMedication.duration * 7);
          break;
        case "Mois":
          endDate.setMonth(startDate.getMonth() + currentMedication.duration);
          break;
      }

      updateCurrentMedication("endDate", endDate.toISOString().split("T")[0]);
    }
  }, [
    currentMedication.startDate,
    currentMedication.duration,
    currentMedication.durationUnit,
    updateCurrentMedication,
  ]);
};